/**
 * 매물 타입 표시 라벨. 백엔드는 RoomType enum 이름(STUDIO/SHAREHOUSE/OFFICETEL/OTHERS/GOSHIWON)을
 * 그대로 내려준다.
 *
 * 라벨을 직접 인덱싱하지 말고 formatRoomType 을 쓸 것 — 맵에 없는 타입이 들어오면 빈칸이 되어
 * 화면에서 티가 나지 않는다. 실제로 GOSHIWON 이 누락된 채 오랫동안 표시되지 않았다.
 */
export const ROOM_TYPE_MAP: Record<string, string> = {
  STUDIO: '원룸',
  SHAREHOUSE: '쉐어하우스',
  OFFICETEL: '오피스텔',
  OTHERS: '기타',
  GOSHIWON: '고시원',
};

/** 매물 타입 → 한글 라벨. 모르는 타입이면 원문을 그대로 노출해 누락을 눈에 띄게 한다. */
export const formatRoomType = (roomType?: string | null): string =>
  roomType ? (ROOM_TYPE_MAP[roomType] ?? roomType) : '';
